const ItemType = {
  PROJECT: "PROJECT",
  OBJECTIVE: "OBJECTIVE",
  STRATEGY: "STRATEGY",
  ACTION: "ACTION"
};

export default ItemType;
